import "./quick-facts.scss";
